import * as ActionTypes from '../ActionTypes';

const initialState = {
    domain_name: "",
    isLoading: false,
    sub_module_data: []
};

const SubModuleReducer = function (state = initialState, action) {
    switch (action.type) {
        case ActionTypes.SUB_MODULE_GET_REQUEST:
            return {
                ...state,
                isLoading: true,
                sub_module_data: []
            };
        case ActionTypes.SUB_MODULE_GET_SUCCESS:
            return {
                ...state,
                isLoading: false,
                success_message: action.payload.message,
                error: action.payload.hasError,
                sub_module_data: action.payload?.data?.data
            };
        default:
            return state;
    }
}

export default SubModuleReducer;